import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the anaerobic threshold.
 **/
export const TextFieldAnaerobicThreshold = ({
    values,
    handleChange,
    errors,
    touched
}) => (
    <TextField
        fullWidth
        label={t('users.fields.vt1HR')}
        type="tel"
        name="anaerobicThreshold"
        value={values.anaerobicThreshold}
        error={touched.anaerobicThreshold && Boolean(errors.anaerobicThreshold)}
        helperText={touched.anaerobicThreshold && errors.anaerobicThreshold}
        onChange={handleChange}
    />
);

TextFieldAnaerobicThreshold.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
